import {connect} from 'react-redux';
import FileUploadForm from './FileUploadForm';
import {flashMessage} from 'shared/actions/notifications';
import {uploadFile} from 'shared/actions/minerva';

export default connect(null, {uploadFile, flashMessage})(FileUploadForm);
